import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {AlertBannerService, AlertType} from 'src/app/lib/alert-banner';
import {SurveyService} from 'src/app/services/survey/survey.service';
import { AiSettingsService, AiSettingsResponse } from 'src/app/services/ai-settings/ai-settings.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-export-settings-modal',
  templateUrl: './export-settings-modal.component.pug',
  styleUrls: ['./export-settings-modal.component.scss'],
  standalone: false
})
export class ExportSettingsModalComponent implements OnInit, OnChanges {

  @Input() refereeId;
  @Input() checkId;
  @Input() competencies: any;
  @Input() modifications: any;
  @Input() user_uid?: any = null;
  @Input() org_uid?: any = null;
  @Output() reportExportStatus = new EventEmitter();
  disableSubmit = false;
  loaded = false;
  submitting = false;
  aiSummaryEnabled = false;
  private aiSettingsSubscription?: Subscription;

  model: any = {
    ai_summary: true,
    coverage: true,
    sentiment: true,
    turnaround_time: true,
    word_count: true,
    candidate_details: true,
    candidate_responses: true,
    referee_details: true,
    core_competencies: true,
    referee_modifications: true,
  };
  constructor(public _bsModalRef: BsModalRef,
              private alertList: AlertBannerService,
              private surveyService: SurveyService,
              private aiSettingsService: AiSettingsService,) {
  }

  ngOnInit() {
    this.aiSettingsSubscription = this.aiSettingsService.aiSettings$.subscribe({
      next: (settings: AiSettingsResponse | null) => {
        this.aiSummaryEnabled = settings?.config?.summary ?? false;
      },
      error: () => {
        this.aiSummaryEnabled = false;
      }
    });
    this.aiSettingsService.getAiSettings().subscribe();
    if (!(this.modifications && this.modifications.length > 0)) {
      delete this.model.referee_modifications;
    }
    if (!this.competencies) {
      delete this.model.core_competencies
    }
  }

  ngOnChanges() {
  }

  submit() {
    this.disableSubmit = true;
    let content = {
      coverage: this.model.coverage,
      sentiment: this.model.sentiment,
      turnaround_time: this.model.turnaround_time,
      word_count: this.model.word_count,
      candidate_details: this.model.candidate_details,
      candidate_responses: this.model.candidate_responses,
      referee_details: this.model.referee_details,
      referee_modifications: this.model.referee_modifications,
      core_competencies: this.model.core_competencies,
    }

    if (this.aiSummaryEnabled) {
      content['ai_summary'] = this.model.ai_summary;
    }
    content['user_uid'] = this.user_uid; //optional
    content['org_uid'] = this.org_uid; //optional
    this.loaded = true;
    this.surveyService.exportPDF(this.checkId, this.refereeId, content,
      () => {
        this.loaded = false;
        this.cancel();
        this.disableSubmit = false;
        this.alertList.append([{
          active: true,
          type: AlertType.SUCCESS,
          message: 'Success! The report has been exported successfully.'
        }]);
        this.reportExportStatus.emit('Success');
      },
      (error) => {
        this.loaded = false;
        this.cancel();
        this.disableSubmit = false;
        this.alertList.append([{
          active: true,
          type: AlertType.DANGER,
          message: 'Oops! Something went wrong. Our developers have been notified. Feel free to try again.'
        }]);
        this.reportExportStatus.emit('Failure');
      }
    );
  }

  ngOnDestroy(): void {
    if (this.aiSettingsSubscription) {
      this.aiSettingsSubscription.unsubscribe();
    }
  }

  cancel() {
    this._bsModalRef.hide();
  }

  checkboxChange() {
    let numberOfSelectedCheckbox = Object.keys(this.model).filter((val) => {
      return this.model[val] === true
    }).length
    // this.disableSubmit = numberOfSelectedCheckbox < 1;
  }
}
